<template>
    <div class="login-component">

        <div class="full-page section-image" data-color="black">
            <div class="content">
                <div class="container">
                    <div class="col-md-offset-3 col-md-6 ml-auto mr-auto form-login">
                        <div class="form">
                            <div class="card card-login">
                                <div class="card-header ">
                                    <!--<div class="logo-block"></div>-->
                                </div>
                                <div class="card-body" v-bind:class="{ shake: loginError }">
                                    <div class="card-body">
                                        <!--<div class="form-group">-->
                                            <!--<label>Email address</label>-->
                                            <!--<input type="text" v-model="username" placeholder="Enter email" class="form-control">-->
                                        <!--</div>-->
                                        <div class="form-group">
                                            <!--<label>Password</label>-->
                                            <div class="container">
                                            <input type="password" v-model="password" placeholder="Пароль" class="form-control">
                                            <button class="btn btn-warning btn-wd" v-on:click="login(username, password)">Войти</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="card-footer ml-auto mr-auto">

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="full-page-background" :style="{ backgroundImage: 'url(' + splash + ')' }"></div>
        </div>


    </div>
</template>
<script>
    const axios = require('axios');

    export default {
        name: 'Login',
        data() {
            return {
                categories: [],
                username: 'admin',
                password: '',
                loginError: false,
                //splash: '/static/img/backgrounds/' + Math.floor((Math.random() * (5 - 1) + 1)).toString() + '.jpg'
                splash: '/static/img/backgrounds/3.jpg'
            }
        },
        created: function() {
            if (localStorage.getItem('token')) {
                this.$router.push('/templates');
            }
            document.getElementsByTagName("html")[0].style.height = "100vh";
        },
        methods: {
            login: function (login, password) {
                let self = this;
                self.loginError = false;

                axios.post(
                    `${this.$hostname}/admin/auth`,
                    {
                        login: login,
                        password: password
                    })
                    .then(function (response) {
                        localStorage.setItem('token', response.data.token);
                        localStorage.setItem('role', parseInt(response.data.role));
                        localStorage.setItem('new-auth-2', "0811");

                        self.$router.push('/templates');
                    })
                    .catch(function (error) {
                        const notification = {
                            template: `<span><b>${error.response.data.message}</b></span>`
                        };

                        self.loginError = true;

                        // self.$notifications.notify(
                        //     {
                        //         component: notification,
                        //         icon: 'nc-icon nc-simple-remove',
                        //         horizontalAlign: 'right',
                        //         verticalAlign: 'top',
                        //         type: 'danger'
                        //     })
                    });


            },
        }
    }
</script>
<style scoped>
    html {
        height: 100vh !important;
    }
    .card-body.shake {
        animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
        transform: translate3d(0, 0, 0);
        backface-visibility: hidden;
        perspective: 1000px;
    }

    @keyframes shake {
        10%, 90% {
            transform: translate3d(-1px, 0, 0);
        }

        20%, 80% {
            transform: translate3d(2px, 0, 0);
        }

        30%, 50%, 70% {
            transform: translate3d(-4px, 0, 0);
        }

        40%, 60% {
            transform: translate3d(4px, 0, 0);
        }
    }
    .card {
        background-color: transparent;
        border: none;
    }
    .card .card-header {
        background-color: transparent;
    }
    .card .card-body {
        padding: 15px 30px 10px 30px;
    }
    .form-login {
        opacity: 1;
        padding-top: 40vh;
        z-index: 999;
    }
    .logo-block {
        display: block;
        width: 100px;
        height: 100px;
        margin: -150px auto;
        background-image: url("/static/img/logo.png");
        background-size: cover;
        border-radius: 6px;
        -webkit-box-shadow: 0 10px 25px 0 rgba(0,0,0,.3);
        box-shadow: 0 10px 25px 0 rgba(0,0,0,.3);
    }
    .full-page-background {
        position: absolute;
        opacity: 0.9;
        z-index: 1;
        height: 100%;
        width: 100%;
        display: block;
        top: 0;
        left: 0;
        background-size: cover;
        background-position: center center;
    }
    .btn-wd {
        background: #fff;
        background-size: cover;
        border: none;
        display: inline-block;
        float: left;
        margin-left: 10px;
        color: #000;
        opacity: 1;
        min-width: 110px;
    }
    .btn-wd:hover, .btn-wd:focus, .btn-wd:active {
        border: none;
    }
    .btn-wd:hover {
        opacity: 0.8;
    }
    .form-control {
        font-weight: 100;
        display: inline-block;
        float: left;
        width: 65%;

    }
    .form-control::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        color: #333333;
        opacity: 1; /* Firefox */
    }

    .form-control:-ms-input-placeholder { /* Internet Explorer 10-11 */
        color: #333333;
    }

    .form-control::-ms-input-placeholder { /* Microsoft Edge */
        color: #333333;
    }

    @media (max-width: 1220px) {
        .form-login {
            padding-top: 30vh;
        }
        .form-control {
            width: 100%;
            float: none
        }
        .btn-wd {
            display: block;
            margin: 20px auto;
            max-width: 140px;
            float: none
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Login.vue